<template>
  <div ref="el" class="dev_config" v-if="showProxy" :style="style">
    <a-popover title=""
               overlayClassName="proxy"
               placement="bottomLeft"
               trigger="hover"
               :arrowPointAtCenter="true"
               :getPopupContainer='triggerNode => triggerNode.parentNode'>

      <template #content>
        <div style="width:400px;">
          <a-select
            size="small"
            style="width: 130px;"
            v-model:value="serviceUrl"
            showArrow
            @change="changeUrl"
            :getPopupContainer="triggerNode => triggerNode.parentNode"
            placeholder="请选择接口根地址">
            <template v-for="item in proxyList" :key="item.url">
              <a-select-option :value="item.configPath">
                {{ item.name }}
              </a-select-option>
            </template>
          </a-select>
          <a-space>
            <span class="btn-proxy" @click="goSite('http://xalb.ecloud.echartnow.cn:3100')">本地力邦</span>
            <span class="btn-proxy" @click="goSite('http://devspp.echartnow.com:3100')">集成</span>
            <span class="btn-proxy" @click="goSite('http://yzntest.ecloud.echartnow.com:3100')">测试</span>
            <span class="btn-proxy"
                  @click="goSite('http://shjxswtest.ecloud.echartnow.com:3100')">测试工业端</span>
          </a-space>
        </div>
      </template>
      <div class="proxy-switch">
        <!--        接口切换-->
        {{currentProxyName}}
      </div>
    </a-popover>

  </div>
</template>

<script lang="ts" setup>
import {ref, unref, reactive, toRaw, computed} from 'vue';
import {getEnv} from "/@/utils/env";
import {getDevProxyList} from "../../../devProxy";
import {useMessage} from "/@/hooks/web/useMessage";
import { useDraggable } from '@vueuse/core'
import customerService from "/@/assets/images/customerService.png";


const {createMessage, createConfirm} = useMessage();
const {serverList, serverName} = getDevProxyList();
const proxyList = ref([]);
const serviceUrl = ref('');
const el = ref<HTMLElement | null>(null)
const { x, y, style } = useDraggable(el, {
  initialValue: { x: 6, y: 20 },
})
const changeUrl = () => {
  sessionStorage.setItem('serviceUrl', serviceUrl.value)
}
const goSite = (url) => {
  window.open(url, '_blank');
}
const currentProxyName = computed(()=>{
  return serverList.find(item=>item.configPath===serviceUrl.value)?.name;
})
const showProxy = ref(false)
if (getEnv() === 'development') {
  showProxy.value = true;
  let sessionProxy = sessionStorage.getItem('serviceUrl');
  console.log('serviceUrl', sessionProxy, '1111111111', serviceUrl.value)
  const isTestEvn = /mdbetest[\w-]*\.echartnow\.com/.test(document.domain)
  if (isTestEvn || document.domain.indexOf('test.ecloud.echartnow.com') != '-1'
    || document.domain.indexOf('cytest09.ecloud.echartnow.com') != '-1'
    || document.domain.indexOf('mthtest01.ecloud.echartnow.com') != '-1'
    || document.domain.indexOf('mthtest10.ecloud.echartnow.com') != '-1'
    || document.domain.indexOf('mthtest03.ecloud.echartnow.com') != '-1'
  ) {
    serviceUrl.value = 'ceshi';
    showProxy.value = false;
  } else if (document.domain.indexOf('dev') != '-1') {
    serviceUrl.value = 'siteboot';
    showProxy.value = false;
  } else {
    if (!serverList.find(item=>item.configPath === sessionProxy)?.configPath) {
      sessionProxy = serverName;
    }
    serviceUrl.value = sessionProxy || serverName;
    proxyList.value = serverList.filter(item => !['ceshi', 'siteboot'].includes(item.configPath));
  }
  sessionStorage.setItem('serviceUrl', serviceUrl.value)
}
</script>

<style lang="less" scoped>
.dev_config {
  position: fixed;
  z-index: 8000;
  background: #fff;
  padding: 4px 8px;
  user-select:none;
  cursor: move;
  display: inline-block;
  font-size: 12px;
  font-weight: 800;;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  .btn-proxy {
    margin-left: 8px;
    cursor: pointer;
    color: #1677ff;
  }
  .proxy-switch {
    display: inline-block;
  }
}
</style>
